import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import { Actions } from "./Action";
import { BASE_URL, CURRENT_ROLE } from "./API/url";

export default function Listen() {
  const dispatch = useDispatch();
  const openState = useSelector(state => state.openQuestions.origOpenData);
  const briefState = useSelector(state => state.brief);
  const {
    newWebSocketRecieved,
    reloadOpenPageData,
    captureAIGeneratedTextFromWebSocket,
    updatePageNumberExpertOpenTab,
    refreshExpertOpenTabData,
    reloadAnsweredtab,
    briefIsLoadingChange,
    briefRespChange,
  } = bindActionCreators(Actions, dispatch);

  const stompClientRef = useRef(null);
  const reconnectAttemptsRef = useRef(0);
  const maxAttempts = 10;

  const connect = () => {
    const sock = new SockJS(`${BASE_URL}/ws-connect`);
    const stompClient = Stomp.over(sock);

    stompClientRef.current = stompClient;

    stompClient.connect({}, (frame) => {
      reconnectAttemptsRef.current = 0; // Reset attempts on successful connect

      stompClient.subscribe("/user/queue/reply", (greeting) => {
        const body = JSON.parse(greeting.body);
        const payload = JSON.parse(body.data);
        appendMsgInNotificationBar(payload);

        if (body.event === 'agentic-flow') {
          briefIsLoadingChange(false);
          briefRespChange(payload.generatedText);
        }
      });
    }, () => {
      // On error, try reconnect
      attemptReconnect();
    });

    sock.onclose = () => {
      attemptReconnect();
    };
  };

  const attemptReconnect = () => {
    if (reconnectAttemptsRef.current < maxAttempts) {
      reconnectAttemptsRef.current++;
      const delay = 1000 * reconnectAttemptsRef.current; // Exponential backoff
      console.warn(`WebSocket disconnected. Attempting to reconnect in ${delay / 1000}s...`);
      setTimeout(() => {
        connect();
      }, delay);
    } else {
      console.error("Max reconnection attempts reached. Giving up.");
    }
  };

  const appendMsgInNotificationBar = async (payload) => {
    if (payload.rfpready) {
      payload.msgType = 'rfp_file_processed';
    }

    const data = {
      header: '',
      icon: '',
      data: {
        status: 'null',
        extraInfo: payload.extraInfo,
        creationDate: Date.parse(new Date()),
        msgUuid: payload.msgUuid,
        queUuid: payload.queUuid
      },
      notification: {
        clickAction: payload.clickAction,
        title: payload.title
      }
    };

    const notify = (header, icon) => {
      data.header = header;
      data.icon = icon;
      newWebSocketRecieved(data);
    }

    switch (payload.msgType) {
      case 'expert_answered':
      case 'another_expert_answered':
      case 'watchlist_user':
        notify('You got answer!', 'fa fa-comments');
        break;
      case 'question updated':
        notify('Your Answer got updated!', 'fa fa-comments');
        break;
      case 'question_shared':
        notify('Shared a question!', 'fa fa-share-alt');
        break;
      case 'expert_clarify':
        notify('Expert asked for a clarification!', 'fa fa-comments');
        break;
      case 'question_deleted':
        notify('Question was deleted!', 'fa fa-trash');
        break;
      case 'request_for_review':
        if(CURRENT_ROLE==='Expert') {
          notify('Request for review!', 'fa fa-comments');
          data.data.msgType = 'request_for_review';
        }
        break;
      case 'rfp_file_processed':
        data.data.msgType = "rfp_file_processed";
        notify("Multi-Question File Processed!", "fa fa-download");
        data.data.extraInfo = 'Ready for download!';
        data.notification.title = "";
        break;
      case 'seeker_clarified':
        notify("Seeker Has Clarified a Question", "fa fa-comments");
        break;
    }

    if (['question_deleted', 'expert_answered'].includes(payload.msgType)) {
      const rand = Math.random() * 10;
      reloadOpenPageData(rand.toString());
      reloadAnsweredtab(rand.toString());
    }

    if (['new_question', 'question_rerouted', 'another_expert_answered'].includes(payload.msgType)) {
      updatePageNumberExpertOpenTab(0);
      refreshExpertOpenTabData(Math.random() * 10);
    }

    if (payload.summaryUuid) {
      captureAIGeneratedTextFromWebSocket(payload);
    }
  };

  useEffect(() => {
    connect();
    return () => {
      if (stompClientRef.current && stompClientRef.current.disconnect) {
        stompClientRef.current.disconnect();
      }
    };
  }, []);

  return <></>;
}